'use client';
// import axios from '../axiosInstance';
import axios from "axios";
import CryptoJS from 'crypto-js';
import { baseUrl, linksytemweb } from "../links";
// قيم ثابتة مثل API Token والمفتاح السري
const secretKey = "MY_SECRET_KEY";
// const appUserAgent = "YourSummerBookingSystem/1.0.0"; // User-Agent مخصص

// دالة لإنشاء توقيع HMAC
const generateSignature = (data) => {
  return CryptoJS.HmacSHA256(data, secretKey).toString(CryptoJS.enc.Base64);
};
const api = axios.create({
  baseURL: baseUrl,
});

async function post(endPoint, data) {
  const timestamp = new Date().getTime().toString();
  const dataToSign = `timestamp=${timestamp}&endpoint=/getData`;
  const signature = generateSignature(dataToSign);
  const token = window.localStorage.getItem('token')
  try {
    const response = await api.post(endPoint, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        "X-App-Source": "YourSummerBookingSystem",   // مصدر التطبيق
        // "x-User-Agent": appUserAgent,     // User-Agent
        "X-Signature": signature,       // التوقيع HMAC
        "X-Timestamp": timestamp,
      },
    });
    if (response.data) {
      if (response.data.success === 500) {
        localStorage.clear();
        window.location.href = linksytemweb;
      }
      else {
        return response.data;
      }
    }
    else {
      console.log("no data is avilabel");
    }
  } catch (err) {
    console.log(err);
  }
};
async function put(endPoint, data) {
  const timestamp = new Date().getTime().toString();
  const dataToSign = `timestamp=${timestamp}&endpoint=/getData`;
  const signature = generateSignature(dataToSign);
  const token = window.localStorage.getItem('token')
  try {
    const response = await api.put(endPoint, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        "X-App-Source": "YourSummerBookingSystem",   // مصدر التطبيق
        // "x-User-Agent": appUserAgent,     // User-Agent
        "X-Signature": signature,       // التوقيع HMAC
        "X-Timestamp": timestamp,
      },
    });
    if (response) {
      if (response.data.success === 500) {
        localStorage.clear();
        window.location.href = linksytemweb;
      }
      else {
        return response.data;
      }
    }
    else {
      console.log("no data is avilabel");
    }
  } catch (err) {
    console.log(err);
  }
};
const get = async (endPoint) => {
  const timestamp = new Date().getTime().toString();
  const dataToSign = `timestamp=${timestamp}&endpoint=/getData`;
  const signature = generateSignature(dataToSign);
  const token = window.localStorage.getItem('token')
  try {
    const response = await api.get(endPoint, {
      headers: {
        'Authorization': `Bearer ${token}`,
        "X-App-Source": "YourSummerBookingSystem",   // مصدر التطبيق
        // "x-User-Agent": appUserAgent,     // User-Agent
        "X-Signature": signature,       // التوقيع HMAC
        "X-Timestamp": timestamp,
      },
    });
    if (response) {
      if (response.data.success === 500) {
        localStorage.clear();
        window.location.href = linksytemweb;
      }
      else {
        return response.data;
      }
    }
    else {
      console.log("no data is avilabel");
    }
  } catch (err) {
    console.log(err);
  }
};
const del = async (endPoint) => {
  const timestamp = new Date().getTime().toString();
  const dataToSign = `timestamp=${timestamp}&endpoint=/getData`;
  const signature = generateSignature(dataToSign);
  const token = window.localStorage.getItem('token')
  try {
    const response = await api.delete(endPoint, {
      headers: {
        'Authorization': `Bearer ${token}`,
        "X-App-Source": "YourSummerBookingSystem",   // مصدر التطبيق
        // "x-User-Agent": appUserAgent,     // User-Agent
        "X-Signature": signature,       // التوقيع HMAC
        "X-Timestamp": timestamp,
      },
    });
    if (response) {
      if (response.data.success === 500) {
        localStorage.clear();
        window.location.href = linksytemweb;
      }
      else {
        return response.data;
      }
    }
    else {
      console.log("no data is avilabel");
    }
  } catch (err) {
    console.log(err);
  }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { post, put, get, del };
